<template>
  <ion-app>
    <ion-content>
      <ion-grid>
        <div class="back-button-bg" @click="gotoBack">
          <ion-icon mode="ios" name="arrow-back" size="large" class="white"></ion-icon>
        </div>
        <p class="page-title">Legal</p>
        <ion-row>
          <ion-col size="12">
            <div class="legal-block">
              <p class="mt-0 mb-4 bold text-xl green">Política de Privacidade</p>
              <p align="justify" class="darkgrey text-sm">
                Esta Política de Privacidade descreve como suas informações
                pessoais são coletadas, usadas e compartilhadas quando você
                visita ou faz uma compra em https://www.updiet.com.br ou no
                aplicativo updiet para dispositivos móveis, abaixo referenciados
                como "Site/App".
                <br />
                <br />
                <span class="thin">INFORMAÇÕES PESSOAIS QUE COLETAMOS</span>
                <br />Quando você visita o Site/App, nós automaticamente coletamos
                certas informações sobre seu dispositivo, incluindo informações
                sobre o seu browser, endereço de IP, fuso horário e alguns dos
                Cookies instalados em seu dispositivo. Adicionalmente, enquanto
                você navega no Site/App, nós coletamos informações sobre quais
                páginas você visualiza, termos você busca e como você interage
                com o Site/App. Nós nos referimos a essas informações coletadas
                automaticamente como "Informações de Dispositivo". Nós coletamos
                informações de dispositivo utilizando as seguintes tecnologias:
                - "Cookies" são arquivos de dados que são colocados no seu
                dispositivo ou computador e geralmente incluem um identificador
                exclusivo anônimo. Para mais informações sobre cookies e como
                desativa-los, visite https://www.allaboutcookies.org. -
                “Arquivos de Log” monitoram ações que ocorrem no Site/app,
                coletando dados incluindo o seu endereço de IP, web browser,
                ISP, páginas de entrada/saída e carimbos de data/horário. - “Web
                beacons,” “tags,” e “pixels” são arquivos eletrônicos usados
                para obter informações sobre como você usa o Site/App. Além
                disso, quando você faz uma compra ou tenta fazer uma compra
                através do Site/App, nós coletamos certas informações suas,
                incluindo seu nome, endereço de cobrança, endereço de entrega,
                forma de pagamento (incluindo números de cartão de crédito e
                contas do Stripe), endereço de e-mail, informações de compra
                (produto, preço e data) e número de telefone. Nós nos referimos
                a essas informações como "Informações de Compra". Quando falamos
                de "Informações Pessoais" nessa Política de Privacidade, nos
                referimos tanto a Informações de Dispositivo como Informações de
                Compra.
                <br />
                <br />
                <span class="thin">COMO NÓS USAMOS SUAS INFORMAÇÕES PESSOAIS?</span>
                <br />Usamos as Informações de Compra que coletamos geralmente para
                atender a quaisquer pedidos feitos por meio do Site/App
                (incluindo o processamento de suas informações de pagamento, a
                organização do envio e o fornecimento de faturas e / ou
                confirmações de pedidos a você). Além disso, usamos essas
                Informações de Compra para: - Comunicar com você; - Examinar
                nossos pedidos quanto a possíveis riscos ou fraudes - Quando
                estiver de acordo com as preferências que você compartilhou
                conosco, fornecer informações ou publicidade relacionada aos
                nossos produtos ou serviços. Usamos as Informações do
                Dispositivo que coletamos para nos ajudar a rastrear possíveis
                riscos e fraudes (em seu endereço IP) e, em geral, para melhorar
                e otimizar nosso Site/App (por exemplo, por gerar análises sobre
                como nossos clientes navegam e interagem com o Site/App e para
                avaliar o sucesso de nossas campanhas de marketing e
                publicidade). Também usamos suas informações pessoais para fins
                de redirecionamento de anúncios.
                <br />
                <br />
                <span class="thin">COMPARTILHANDO SUAS INFORMAÇÕES PESSOAIS</span>
                <br />Usamos o Google Analytics para nos ajudar a entender como nossos
                clientes usam o Site/App - você pode ler mais sobre como o
                Google usa suas informações pessoais aqui:
                https://www.google.com/intl/en/policies/privacy/. Você também
                pode optar por não participar do Google Analytics Aqui:
                https://tools.google.com/dlpage/gaoptout. Por fim, também
                podemos compartilhar suas informações pessoais para cumprir as
                leis aplicáveis e regulamentos, para responder a uma intimação,
                mandado de busca ou outro pedido legal de informação que
                recebermos, assim como para proteger nossos direitos.
                <br />
                <br />
                <span class="thin">PUBLICIDADE COMPORTAMENTAL</span>
                <br />Conforme descrito acima, usamos suas informações pessoais para
                fornecer a você anúncios ou comunicações de marketing que
                acreditamos ser do seu interesse. Para mais informações sobre
                como funciona a publicidade direcionada, você pode visitar a
                página educacional da Network Advertising Initiative ("NAI") em
                https://www.networkadvertising.org/understanding-online-advertising/how-does-it-work.
                Você pode desativar a publicidade direcionada por:
                <br />
                <br />&#183; FACEBOOK - https://www.facebook.com/settings/?tab=ads
                <br />&#183; GOOGLE - https://www.google.com/settings/ads/anonymous
                <br />&#183; BING -
                https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads
                <br />
                <br />Além disso, você pode optar por não receber alguns desses
                serviços visitando o portal de desativação da Digital
                Advertising Alliance em: https://optout.aboutads.info/.
                <br />
                <br />
                <span class="thin">NÃO MONITORAR</span>
                <br />Observe que não alteramos a coleta de dados do nosso Site/App e
                usamos as mesmas práticas quando nos deparamos com um "Não
                Monitorar" de seu navegador ou dispositivo.
                <br />
                <br />
                <span class="thin">SEUS DIREITOS</span>
                <br />Se você é um residente europeu, tem o direito de acessar as
                informações pessoais que possuímos sobre você e solicitar que
                suas informações pessoais sejam corrigidas, atualizadas ou
                excluídas. Se você gostaria de exercer esse direito, entre em
                contato conosco através das informações de contato explicitadas
                ao final deste document. Além disso, se você é um residente
                europeu, declaramos que estamos processando suas informações
                para cumprir contratos que possamos ter com você (por exemplo,
                se você fizer uma compra neste Site/App) ou de outra forma para
                atingir nossos interesses comerciais legítimos listados acima.
                Além disso, por favor observe que suas informações serão
                transferidas para fora da Europa, inclusive para o Canadá e a
                Estados Unidos.
                <br />
                <br />
                <span class="thin">RETENÇÃO DE DADOS</span>
                <br />Quando você insere dados no Site/App, nós manteremos estes dados
                em nossos registros exceto se (e até que) você solicite a
                remoção por correio, no endereço explicitado ao final deste
                documento.
                <br />
                <br />
                <span class="thin">ALTERAÇÕES</span>
                <br />Podemos atualizar esta Política de Privacidade periodicamente
                para refletir, por exemplo, mudanças nas nossas práticas ou
                outros motivos operacionais, legais ou regulatórios.
                <br />
                <br />
                <span class="thin">CONTATE-NOS</span>
                <br />Para obter mais informações sobre nossas práticas de
                privacidade, se você tiver alguma dúvida ou se desejar fazer uma
                reclamação, entre em contato conosco pelo e-mail
                help@updiet.com.br ou pelo correio utilizando os detalhes
                fornecidos abaixo: Pessoa Jurídica: Patrick de Castro Neuhaus
                ME. CNPJ: 21.161.967.0001-25. Endereço: 02301-140 - Travessa
                Benedito Acacio Gonçalves 31, São Paulo/Brasil.
              </p>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-app>
</template>

<script>
export default {
  name: "LegalDocuments",
  methods: {
    gotoBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
ion-content {
  --background: linear-gradient(
    180deg,
    var(--ion-color-primary),
    white,
    white
  ) !important;
}
ion-grid {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
ion-col {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.back-button-bg {
  z-index: 1001;
}
.legal-block {
  margin-top: 80px;
  width: 100%;
  padding-top: 40px;
  padding-left: 10vw;
  padding-right: 10vw;
  padding-bottom: 20px;
  box-shadow: 0 -6px 6px -6px rgba(0, 0, 0, 0.15);
  background: white !important;
}
</style>
